<svg:path
  *ngIf="model.type === 'default'"
  (mousedown)="onEdgeMouseDown()"
  [attr.d]="model.path().path"
  [attr.marker-start]="markerStartUrl()"
  [attr.marker-end]="markerEndUrl()"
  class="edge"
  [class.edge_selected]="model.selected()"
/>

<ng-container *ngIf="model.type === 'template' && edgeTemplate">
  <ng-container
    [ngTemplateOutlet]="edgeTemplate"
    [ngTemplateOutletContext]="edgeContext"
    [ngTemplateOutletInjector]="injector"
  ></ng-container>
</ng-container>

<ng-container *ngIf="model.edgeLabels?.start as label">
  <svg:g edgeLabel
    [model]="label"
    [point]="model.path().points.start"
    [edgeModel]="model"
    [htmlTemplate]="edgeLabelHtmlTemplate"
  />
</ng-container>

<ng-container *ngIf="model.edgeLabels?.center as label">
  <svg:g edgeLabel
    [model]="label"
    [point]="model.path().points.center"
    [edgeModel]="model"
    [htmlTemplate]="edgeLabelHtmlTemplate"
  />
</ng-container>

<ng-container *ngIf="model.edgeLabels?.end as label">
  <svg:g edgeLabel
    [model]="label"
    [point]="model.path().points.end"
    [edgeModel]="model"
    [htmlTemplate]="edgeLabelHtmlTemplate"
  />
</ng-container>
